import LoadingSpinner from './LoadingSpinner'

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/index.js